import { Country } from '../models/CountryDTO';

export const getCountryNameByCode = (countryCode: string, countryData: Country[]) => {
    if (!countryCode) return null;
    if (!countryData) return countryCode;
    return countryData.find((c) => c.alpha3Code === countryCode)?.name;
};
